import React, { Component } from 'react';
import ReactJWPlayer from 'react-jw-player';

import externalConfiguration from '../external-configuration';
import { isIE11, IE11_safeIncludes } from '../helpers/utils';

import defaultProps from './default-props';
import propTypes from './prop-types';

// import getPlayerSettings from '../helpers/get-player-settings';    // TODO
// import getMediaOriginSettings from '../helpers/get-media-origin-settings';
import { patchM3u8Url, promiseAny, testContent } from '../helpers/utils';
import { vdmReadDesign, vdmReadSharing } from '../helpers/vdm-to-state';
import PlayerDataSender from '../helpers/PlayerDataSender';

import './base-player.css';

const displayName = 'BasePlayer';
const UrlSplitRE = /^(https?:)?(\/\/[^/]+)?(.*)/;
const UrlImageSplitRE = /^(https?:)?(\/\/[^/]+)?((\/[^/?]+)*)(\/[^/?]+)(\?.*)?$/;

class BasePlayer extends Component {
  constructor(props) {
    super(props);
    // console.log( 'BasePlayer - constructor - props: ', props);   // DEVELOP
    this.onReady = this.onReady.bind(this);
    let autoplayMute = false;
    if( 'autostart' in this.props.customProps && this.props.customProps.autostart && this.props.customProps.autostart !== 'false'){
      this.props.customProps.mute = true;      // PATCH: Debido a actualizaciones de los navegadores, en algunos casos no se puede usar autoplay con sonido.
      autoplayMute = true;                     // TODO: Compobar si realmente es necesario, o moverlo a playAttemptFailed (al actualizar a jwplayer 8)
    }
    if( 'force_autoplay' in this.props.customProps && this.props.customProps.force_autoplay && this.props.customProps.force_autoplay !== 'false'){
      this.props.customProps.autostart = true;
    }
    this.state = {
      state: 'Loading',
      playlist: [],
      autoplayMute,
      displayMultiChannel: false,
      key: Math.random(),
    };
    this.testAndChooseSrc = this.testAndChooseSrc.bind(this);
    this.pendingStart = true;
  }
  testAndChooseSrc( element, skipBase = false) {
    // console.log( 'testAndChooseSrc - element: ', element, ', element.file: ', element.file);   // DEVELOP
    // Super Patch Furious
    const purgeQueryOtherThanToken = url => {
      const splitedUrl = url.split('?');
      const splitedQuery = splitedUrl && splitedUrl.length > 1 && splitedUrl[1].split('&');
      const potentialToken = splitedQuery && splitedQuery.length > 1 && splitedQuery[0].split('=');
      if( potentialToken && potentialToken.length <= 1) {
        splitedUrl[1] = splitedQuery[0];
        url = splitedUrl.join('?');
      }
      return url;
    }
    // End of Super Patch Furious
    const insertExtraToken = url => {
      const token = this.props.basePlayerOptions.token;
      if( token) {
        const splitted = url && url.split('?');
        const baseQueryString = splitted[1] && `&${splitted[1]}` || '';
        return `${splitted[0]}?${token}${baseQueryString}`;
      } else {
        return url;
      }
    };
    const setTestQueryString = url => {
      return purgeQueryOtherThanToken( url + ( url && IE11_safeIncludes( url, '?') ? '&' : '?' ) + 'test');
    };
    const removeDVRQueryString = url => {
      return url.replace( '?DVR', '?');
    };
    const generateDomainsListAndFile = url => {
      const Match = UrlSplitRE.exec(insertExtraToken(url));
      const Domain = Match[2] in externalConfiguration.backupPlaybackDomains ? Match[2] : 'default';
      const File = /^\//.test(Match[3]) ? Match[3] : '/' + Match[3];
      let domainsList = [Match[2]].concat( externalConfiguration.backupPlaybackDomains[ Domain]);
      if( this.props.basePlayerOptions.token && Match[2] in externalConfiguration.tokenOverridenPlaybackDomains) {
        domainsList = externalConfiguration.tokenOverridenPlaybackDomains[ Match[2]];
      }
      return { domainsList, File };
    };
    const generatePromisesListFromDomainsListAndFile = (domainsList, File) => {
      return domainsList.map( domain => {
        return fetch( domain + setTestQueryString(File), { method: 'HEAD' }).then( response => {
          // return fetch( domain + File, { method: 'HEAD', mode: 'no-cors'}).then( response => { // REVIEW: esto deberia permitir hacer la comprobacion de forma opaca para que funcione sin cors, pero si es opaca no hay forma de comprobar si la respuesta a fallado.
          // console.log( 'DEVELOP testing: ', domain + File, ', response: ', response);   // DEVELOP
          if(response.ok) {       // && response.data << m3u8
            // element.file = domain + File;
            // return true;
            return domain + File;
          }
          return Promise.reject();
        });
      });
    };
    const { domainsList, File } = generateDomainsListAndFile( element.file);
    const { domainsList: errorDomainsList, File: errorFile } = generateDomainsListAndFile( (this.props.errorMedia && this.props.errorMedia.file) || '');
    let promisesList = [];
    // console.log( 'skipBase: ', skipBase);
    if( !skipBase) {
      // console.log( 'in');
      promisesList = promisesList.concat(
        generatePromisesListFromDomainsListAndFile( domainsList, File),
        generatePromisesListFromDomainsListAndFile( errorDomainsList, errorFile),
      );
    }
    if( File.indexOf('?DVR') > -1) {
      promisesList = promisesList.concat(
        generatePromisesListFromDomainsListAndFile( domainsList, removeDVRQueryString(File)),
        generatePromisesListFromDomainsListAndFile( errorDomainsList, removeDVRQueryString(errorFile)),
      );
    }
    const prioritazedPromisesList = promisesList.map( (promise,i) => {
      return new Promise( (resolve,reject) => {
        const precedentPromises = promisesList.slice( 0, i);
        Promise.all( precedentPromises.map( precedentPromise => {
          return new Promise( (prevResolve,prevReject) => {
            precedentPromise.catch( prevResolve);
          });
        })).then( () => {
          promise.then( resolve);
        });
        promise.catch( reject);
      });
    });
    return promiseAny( prioritazedPromisesList).then( selected => {
      element.file = selected;
    }).catch( () => {
      try {
        const alternativeProgressive = element.progressive;
        if( !alternativeProgressive) return element.file = externalConfiguration.defaultErrorVideo;
        return fetch( setTestQueryString(alternativeProgressive), { method: 'HEAD' }).then( response => {
          if( response.ok) {
            return element.file = alternativeProgressive;
          } else {
            return Promise.reject();
          }
        }).catch( () => {
          return element.file = externalConfiguration.defaultErrorVideo;
        });
      } catch(e) {
        return element.file = externalConfiguration.defaultErrorVideo;
      }
    })
  }
  testAndChooseImage( element) {
    // const isExcluded = ( type, srcType) => {
    //   return type === 'Live' || type === 'Vdm' ||  type === 'Tagging' || ( type === 'Chat' && srcType === 'live');   // Unnecessary to the new platform
    // }
    let routesList = [element.image];
    // if( !isExcluded( this.props.visualizerType, this.props.visualizerOptions.srcType)) {                             // Unnecessary to the new platform
    //   const Match = UrlImageSplitRE.exec(element.image).map( m => (m !== undefined ? m : ''));
    //   routesList = [
    //     element.image + '',   // Force string copy
    //     Match[1] + Match[2] + Match[3] + '/' + Match[5].slice(2) + Match[6],
    //     Match[1] + Match[2] + Match[3] + '/S' + Match[5].slice(2) + Match[6],
    //   ];
    // }
    const promisesList = routesList.map( route => {
      // return fetch( route, { method: 'HEAD', mode: 'no-cors'}).then( response => {    // REVIEW: esto deberia permitir hacer la comprobacion de forma opaca para que funcione sin cors, pero si es opaca no hay forma de comprobar si la respuesta a fallado.
      return fetch( route, { method: 'HEAD' }).then( response => {
        if(response.ok) {       // && response.data << image
            element.image = route;
            return Promise.resolve( true);
        }
        return Promise.resolve( false);
      }).catch(()=>Promise.resolve(false));
    });
    return Promise.all( promisesList).then( (flags) => {
      let found = false;
      flags.forEach( (flag,i) => {
        if( !found && flag) {
          found = true;
          element.image = routesList[i];
        }
      });
      if( !found) {
        element.image = externalConfiguration.defaultImageDown;
      }
    });
  }
  componentDidMount() {
    if( 'injectSrc' in this.props.customProps) {
      this.props.playlist[0].file = patchM3u8Url( this.props.customProps.injectSrc);
    }
    if( 'demoBackup' in this.props.basePlayerOptions) {
      const demoBackup = this.props.basePlayerOptions.demoBackup;
      this.props.playlist[0].file = demoBackup.list[ demoBackup.current];
    }
    if( 'demoMultiChannel' in this.props.basePlayerOptions) {
      const demoMultiChannel = this.props.basePlayerOptions.demoMultiChannel;
      this.props.playlist[0].file = demoMultiChannel.list[ demoMultiChannel.current];
    }
    if( !( 'disableManualSeek' in this.props.basePlayerOptions) || !( this.props.basePlayerOptions.disableManualSeek)) {
      this.props.customProps.playbackRateControls = externalConfiguration.defaultPlaybackRateControls;
    }
    switch( this.props.contentType) {
      case 'SingleMedia':
      case 'Playlist':
        if( this.props.legacy) {
          const playlist = JSON.parse( JSON.stringify( this.props.playlist));
          let startFromVideo = this.props.basePlayerOptions.startFromVideo;
          if( !startFromVideo) startFromVideo = 0;
          let choosedFirst = false;
          playlist.forEach( (element,i) => {
            if( 'tracks' in element) {
              element.tracks.forEach( track => {
                if( track.kind === 'captions' && track.label === this.props.basePlayerOptions.defaultLanguage) {
                  track.default = true;
                }
              });
            }
            if( 'image' in this.props.customProps) {
              element.image = this.props.customProps.image;
              this.testAndChooseSrc( element).then( () => {
                if( choosedFirst || i === startFromVideo) {
                  choosedFirst = true;
                  this.setState( { state: 'Loaded', playlist});
                }
              });
            } else {
              this.testAndChooseImage( element).then( () => {
                this.testAndChooseSrc( element).then( () => {
                  if( choosedFirst || i === startFromVideo) {
                    choosedFirst = true;
                    this.setState( { state: 'Loaded', playlist});
                  }
                });
              });
            }
          });
          // let promisesList = this.props.playlist.map( (element) => this.testAndChooseSrc( element));   // REVIEW:
          // Promise.all( promisesList).then( () => {
          //   this.setState( { state: 'Loaded'});
          // });
        // } else {    // TODO
        //   let customProps = getPlayerSettings( this.props.playerId); // Todo el codigo de estos dos es solo de prueba, y debe cambiarse a uno que devuelva promesas, del estilo del de visualizer
        //   let playlist = getMediaOriginSettings( this.props.mediaOriginId);  // Probablemente mediaOriginId deberia ser lista, para soportar playlist
        //   this.state = {
        //     state: 'Loaded',
        //   };
        }
        break;
      case 'MainWithBackups':
        this.setState({ state: 'Loaded', playlist: this.props.playlist });
        break;
      case 'BalancedFallbacks':
        this.setState({ state: 'Loaded', playlist: this.props.playlist });
        break;
      case 'MultiChannel':
        this.setState({ state: 'Loaded', playlist: this.props.playlist });
        break;
      default:
        throw 'Error: contentMediasType no reconocido.';
    }
  }
  componentWillUnmount() {
      // TODO: Pendiente de cancelar las promesas, emitira un warning si se desmonta el componenete antes de que se cumplan.
  }
  render() {
    // console.log( 'BaePlayer - render - props: ', this.props, ', state: ', this.state);  // DEVELOP
    this.props.customProps.primary = isIE11() ? 'flash' : 'html5';
    const removeAutoMute = () => {
      window.jwplayer(externalConfiguration.defaultPlayerContainerId).setMute( false);
      this.setState({ autoplayMute: false});
    }
    const changeDemoMultiChannel = () => {
      const demoMultiChannel = this.props.basePlayerOptions.demoMultiChannel;
      demoMultiChannel.current = (demoMultiChannel.current + 1) % 2;
      this.state.playlist[0].file = demoMultiChannel.list[ demoMultiChannel.current];
      this.props.customProps.autostart = true;
      this.testAndChooseSrc( this.state.playlist[0]).then( () => {
        this.setState( { key: Math.random()});
      });
    }
    const demoMultiChannelIconUrl = () => {
      const demoMultiChannel = this.props.basePlayerOptions.demoMultiChannel;
      return demoMultiChannel.iconList[ demoMultiChannel.current];
    }
    // console.log( 'multiChannel: ', this.props.basePlayerOptions.multiChannel);
    const setDisplayMultiChannel = value => {
      // console.log( 'setDisplayMultiChannel - value: ', value);
      this.setState({ displayMultiChannel: value });
    }
    const changeMultiChannel = i => {
      // console.log( 'changeMultiChannel - i: ', i);
      const multiChannel = this.props.basePlayerOptions.multiChannel;
      multiChannel.current = i;
      this.state.playlist[0] = multiChannel.medias[ multiChannel.current];
      if( !this.pendingStart) this.props.customProps.autostart = true;
      this.setState({ key: Math.random() });
    }
    let extraBaseClassNames = [];
    if( this.props.basePlayerOptions.disableManualSeek) {
      extraBaseClassNames.push( 'disable-manual-seek');
    }
    if( this.state.autoplayMute) {
      extraBaseClassNames.push( 'disable-jw-icons');
    }
    let jwPlayerSelfHostedPath = externalConfiguration.jwPlayerSelfHostedPath;
    if( this.props.basePlayerOptions.lowLatency) jwPlayerSelfHostedPath = externalConfiguration.jwPlayerSelfHostedPath_lowlatency;
    switch( this.state.state) {
      case 'Loaded':
        if( this.player && ( this.player.getWidth() !== this.props.customProps.width || this.player.getHeight() !== this.props.customProps.height ) ){
          this.player.resize( this.props.customProps.width, this.props.customProps.height);
        }
        return (
          <div className={ 'custom-jw-player ' + extraBaseClassNames.join( ' ') }>
            <ReactJWPlayer
              playerId={externalConfiguration.defaultPlayerContainerId}
              playerScript={jwPlayerSelfHostedPath}
              playlist={this.state.playlist}
              customProps={this.props.customProps}
              licenseKey={externalConfiguration.jwPlayerLicenseKey}
              onReady={this.onReady}
              key={this.state.key}
            />
            { this.state.autoplayMute ?
              <div className='autoplay-mute' style={{
                'backgroundColor': this.props.customProps.skin.background,
              }}>
                <img src='/vdmplayer/resources/mute.png' className='autoplay-mute-button' onClick={removeAutoMute}/>
              </div>
            : '' }
            { 'demoMultiChannel' in this.props.basePlayerOptions ?
              <div className='changel-channel' style={{
                'backgroundColor': this.props.customProps.skin.background,
              }}>
                <img src={demoMultiChannelIconUrl()} className='changel-channel-button' onClick={changeDemoMultiChannel}/>
              </div>
            : '' }
            { 'multiChannel' in this.props.basePlayerOptions ?
              <div className='change-channel' style={{
                'backgroundColor': this.props.customProps.skin.background,
              }}>
                { this.state.displayMultiChannel ? <div className='change-channel-menu' style={{ 'backgroundColor': this.props.customProps.skin.background }}>
                  { this.props.basePlayerOptions.multiChannel.medias.map( (media,i) => <img
                    className='change-channel-button'
                    src={this.props.basePlayerOptions.multiChannel.iconUrls[i]}
                    onClick={() => changeMultiChannel(i)}
                  />) }
                </div> : '' }
                <img src={this.props.basePlayerOptions.multiChannel.mainIconUrl} className='change-channel-button' onClick={() => setDisplayMultiChannel(!this.state.displayMultiChannel)}/>
              </div>
            : '' }
          </div>
        );
      case 'Loading':
        // return <li> Player loading. </li>;    // DEVELOP
        return null;
      default:
        // return <li> Error desconocido en el funcionamiento del player.</li>;   // DEVELOP
        return null;
    }
  }
  postMessageApiHandler( event, player) {
    switch( event.data.operation) {
      case 'pause':
        player.pause( event.data.value);
        break;
      case 'seek':
        let time = parseInt( event.data.time, 10);
        const duration = player.getDuration();
        if( event.data.forcePositive && duration < 0) {
          time += duration;
        }
        player.seek( time);
        this.forcePauseAfterSeek = event.data.forcePause;
        break;
      case 'getMp4Url':
        event.source.postMessage( { mp4Url: player.getPlaylistItem().progressive, token: event.data.token }, event.origin);
        break;
      case 'getCurrentSecond':
        let second = player.getPosition();
        if( event.data.forcePositive && second < 0) {
          second = Math.abs(player.getDuration()) + second;
        }
        event.source.postMessage( { second, token: event.data.token }, event.origin);
        break;
      case 'getDuration':
        event.source.postMessage( { seconds: player.getDuration(), token: event.data.token }, event.origin);
        break;
      case 'getPlaylistInfo':
        const programmationInfo = this.props.basePlayerOptions.programmationInfo || {};
        const Response = {
          currentElement: player.getPlaylistItem().index || 0,
          effectiveTimeStampStart: programmationInfo.effectiveTimeStampStart,
          mode: programmationInfo.mode,
          finalDate: programmationInfo.finalDate,
          playlist: this.state.playlist,
          token: event.data.token,
        };
        event.source.postMessage( Response, event.origin);
        break;
      case 'getImage':
        const video = document.getElementsByTagName('video')[0];
        console.log( video);
        const canvas = document.createElement('canvas');
        console.log( canvas);
        canvas.width = video.width || video.videoWidth;
        canvas.height = video.height || video.videoHeight;
        canvas.getContext('2d').drawImage( video, 0, 0, canvas.width, canvas.height);
        console.log( canvas);
        canvas.toBlob( blob => {
          console.log( blob);
          event.source.postMessage( { image: blob, token: event.data.token }, event.origin);
        });
        break;
      case 'changeStreamOrigin':
        player.load([{ file: patchM3u8Url( event.data.streamOrigin)}]);
        this.justLoad = true;   // Estas dos lineas son parte de un parche exlicado mas abajo en "player.on( 'time'," en la version en limpio deberia haber una
        this.startFromSecond = parseInt( event.data.time, 10);    // llamada a seek.
        break;
      case 'updateSettings':
        const customProps = Object.assign( {}, this.props.customProps);
        const basePlayerOptions = Object.assign( {}, this.props.basePlayerOptions);
        if( 'design' in event.data) {
          vdmReadDesign( event.data.design || {}, {customProps});
        }
        if( 'socialSharing' in event.data) {
          vdmReadSharing( event.data.socialSharing || [], {customProps});
        }
        if( 'download' in event.data) {
          basePlayerOptions.download = event.data.download;
        }
        this.setState( Object.assign( {}, this.state, { key: Math.random()}));
        this.props.visualizer.setState( { customProps, basePlayerOptions});
        break;
      default:
    }
  }
  onReady() {
    let player = this.player = window.jwplayer(externalConfiguration.defaultPlayerContainerId);
    player.on( 'time', ( e) => {
      this.pendingStart = false;
      if( this.uniqueOnTime){
        this.uniqueOnTime( e);
      }
      if( this.justLoad && e.position !== 0){   // Esto es parte de un parche, necesario para rodear un bug de jwplayer, justo despues de llamar a la funcion load
        player.seek( this.startFromSecond);     //  la funcion seek, no funciona correctamente, hasta que no comienza la reproduccion
        this.justLoad = false;
      }
    });
    if( this.props.basePlayerOptions.disableManualSeek) {
      player.on( 'pause', (args) => {
        player.pause( false);
      });
    }
    player.on( 'seeked', (args) => {
      if( this.forcePauseAfterSeek) {
        this.forcePauseAfterSeek = false;
        player.pause( true);
      }
    });
    player.on( 'error', (args) => {
      // console.log( 'Custom on error: ', args);   // DEVELOP
      if( 'balancedFallbacks' in this.props.basePlayerOptions) {
        const balancedFallbacks = this.props.basePlayerOptions.balancedFallbacks;
        balancedFallbacks.current = (balancedFallbacks.current + 1) % balancedFallbacks.medias.length;
        this.state.playlist[0] = balancedFallbacks.medias[ balancedFallbacks.current];
        if( !this.pendingStart) this.props.customProps.autostart = true;
        this.setState({ key: Math.random() });
      } else if( 'mainWithBackups' in this.props.basePlayerOptions) {
        const mainWithBackups = this.props.basePlayerOptions.mainWithBackups;
        mainWithBackups.current = (mainWithBackups.current + 1) % mainWithBackups.medias.length;
        this.state.playlist[0] = mainWithBackups.medias[ mainWithBackups.current];
        if( !this.pendingStart) this.props.customProps.autostart = true;
        this.setState({ key: Math.random() });
      } else {
        let skipBase = true;
        if( 'demoBackup' in this.props.basePlayerOptions) {
          const demoBackup = this.props.basePlayerOptions.demoBackup;
          demoBackup.current = (demoBackup.current + 1) % 2;
          this.state.playlist[0].file = demoBackup.list[ demoBackup.current];
          skipBase = false;
          this.props.customProps.autostart = true;
        }
        this.state.playlist.forEach( (element,i) => {
          this.testAndChooseSrc( element, skipBase).then( () => {
            this.setState( { key: Math.random()});
          });
        });
       }
    });
    if( 'demoBackup' in this.props.basePlayerOptions) {
      const demoBackup = this.props.basePlayerOptions.demoBackup;
      if( demoBackup.interval) {
        // console.log( 'CLEARING INTERVAL');
        clearInterval( demoBackup.interval);
      } else {
        // console.log( 'SETTING CLEAN INTERVAL');
      }
      // if( !demoBackup.counter) demoBackup.counter = 0;
      // const myInterval = demoBackup.counter++;
      demoBackup.interval = setInterval( () => {
        // console.log( 'executing interval n: ', myInterval);
        fetch( this.state.playlist[0].file, { method: 'HEAD' }).then( response => {
          if( !response.ok) {
            demoBackup.current = (demoBackup.current + 1) % 2;
            this.state.playlist[0].file = demoBackup.list[ demoBackup.current];
            this.props.customProps.autostart = true;
            this.testAndChooseSrc( this.state.playlist[0]).then( () => {
              this.setState( { key: Math.random()});
            });
          }
        });
      }, 3000);
    }
    if( 'mainWithBackups' in this.props.basePlayerOptions) {
      const mainWithBackups = this.props.basePlayerOptions.mainWithBackups;
      if( mainWithBackups.interval) {
        // console.log( 'CLEARING MAIN_WITH_BACKUPS INTERVAL');
        clearInterval( mainWithBackups.interval);
      } else {
        // console.log( 'SETTING CLEAN MAIN_WITH_BACKUPS INTERVAL');
      }
      mainWithBackups.interval = setInterval( () => {
        const previousMedia = mainWithBackups.medias.slice( 0, mainWithBackups.current);
        mainWithBackups.onionPromise = Promise.reject( 'base reject');
        previousMedia.forEach( (media, tested) => {
          const previousPromise = mainWithBackups.onionPromise;
          mainWithBackups.onionPromise = new Promise( (resolve, reject) => {
            previousPromise.then( resolved => resolve(resolved)).catch( () => {
              testContent( media.file).then( response => {
                mainWithBackups.current = tested;
                this.state.playlist[0] = mainWithBackups.medias[ mainWithBackups.current];
                if( !this.pendingStart) this.props.customProps.autostart = true;
                this.setState({ key: Math.random() });
                resolve( tested);
              }).catch( rejection => {
                reject( `${tested} reject`);
              });
            });
          });
        });
        mainWithBackups.onionPromise.then( resolved => {
          console.log( `MAIN_WITH_BACKUPS RESOLVED ON: ${resolved}`);
        }).catch( lastRejected => {
          console.log( `MAIN_WITH_BACKUPS LAST REJECTED: ${lastRejected}`);
        });
      }, 3000);
    }
    // if( 'mainWithBackups' in this.props.basePlayerOptions) {
    //   const mainWithBackups
    // }
    window.addEventListener('message', (event) => this.postMessageApiHandler( event, player), false);   //TODO: guardarlo en el estado para poder borrarlo al desmontar.
    if( this.props.basePlayerOptions.download && this.props.basePlayerOptions.download !== '' && this.props.basePlayerOptions.download !== 'false') {
      player.addButton(
        externalConfiguration.defaultDownloadButtonImage,
        'Download Video',
        () => { window.location.href = player.getPlaylistItem().progressive},
        'download',
      );
    }
    if( this.props.basePlayerOptions.extraButtons) this.props.basePlayerOptions.extraButtons.forEach( button => {
      player.addButton( button.imgSrc, button.text, () => this.props.visualizer.setState( button.handler(this.props)), button.id);
    });
    if( this.props.basePlayerOptions.startFromVideo) {
      player.playlistItem( this.props.basePlayerOptions.startFromVideo);
    }
    player.on( 'firstFrame', () => {
      if( this.props.basePlayerOptions.startFromSecond) {
        player.seek( this.props.basePlayerOptions.startFromSecond);
        this.props.basePlayerOptions.startFromSecond = 0;
      }
    });
    this.playerDataSender = new PlayerDataSender(player,this);
    if( this.props.getPlayer){
      this.props.getPlayer( player, this);
    }
    // Initialize Mux Data monitoring
    // let mux_tag = document.createElement( 'script');
    // mux_tag.async = true;
    // mux_tag.type = 'text/javascript';
    // mux_tag.src = 'https://src.litix.io/jwplayer/2/jwplayer-mux.js';
    // mux_tag.onload = () => {
    //   window.initJWPlayerMux(player, {
    //     debug: true,
    //     data: {
    //       property_key: 'de6uvffvimi96hsrt1hngiu8r', // required
    //       // Metadata
    //       // player_name: '', // ex: 'My Main Player'
    //       // player_init_time: Date.now(),
    //       // ... and other metadata
    //     }
    //   });
    // }
    // const last_script = document.getElementsByTagName("script")[0];
    // last_script.parentNode.insertBefore( mux_tag, last_script);

    // Initialize dekalabs data monitoring
    // if( this.props.visualizerType !== 'Vdm') {
      let dekalabs_logger_tag = document.createElement( 'script');
      dekalabs_logger_tag.async = true;
      dekalabs_logger_tag.type = 'text/javascript';
      dekalabs_logger_tag.src = 'https://stats.codev8.net/custom_logger.js';
      // dekalabs_logger_tag.src = 'https://maquina.codev8.net/custom_logger.js';
      dekalabs_logger_tag.onload = () => {
        // console.log( 'logger: ', this, window.CUSTOM_LOGGER);   // DEVELOP
        this.user = this.props.basePlayerOptions.platformId;
  			if( /^(https?:)?\/\/[^/]+\/(video|ondemand)\//.exec( this.props.playlist[0].file) !== null) {
          const regexp = /\/(([^/]*)_H,?([0-9]+,)*[0-9]+,?.mp4)(.m3u8)?/;
          const element = this.props.playlist[0];
          const test = regexp.exec( element.file) || regexp.exec( element.progressive) || [];
  				this.loggerId = test[2];
          // if( !('user' in this) || !this.user) {
          //   this.user = /\/([^/]*)\/[^/]*_H,?([0-9]+,)*[0-9]+,?.mp4.m3u8/.exec( this.props.playlist[0].file)[1];
          // }
          // console.log( 'CUSTOM_LOGGER - VOD: ', this.loggerId, this.user);   // DEVELOP
  				window.CUSTOM_LOGGER.addVideo( this.user, this.loggerId, document.getElementsByClassName('jw-video')[0]);
  			} else {
  				this.loggerId = /\/((amlst|smil):)?([^/.]+)(\.(amlst|smil))?\/[^/]+.m3u8(\?[^?]*)?/.exec( this.props.playlist[0].file)[3];
          // if( !('user' in this) || !this.user) {
          //   this.user = /\/([^/]*)live\/((amlst|smil):)?[^/.]+(\.(amlst|smil))?\/[^/]+.m3u8(\?[^?]*)?/.exec( this.props.playlist[0].file)[1];
          // }
          // console.log( 'CUSTOM_LOGGER - LIVE: ',this.loggerId, this.user);   // DEVELOP
  				window.CUSTOM_LOGGER.addStream( this.user, this.loggerId, document.getElementsByClassName('jw-video')[0]);
  			}
  			window.CUSTOM_LOGGER.init();
      };
      const last_script = document.getElementsByTagName('script')[0];
      last_script.parentNode.insertBefore( dekalabs_logger_tag, last_script);
    // }
  }
}

BasePlayer.defaultProps = defaultProps;
BasePlayer.displayName = displayName;
BasePlayer.propTypes = propTypes;
export default BasePlayer;



// WEBPACK FOOTER //
// ./src/base-player/base-player.js